import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import Page from 'src/components/Page';
import ProfileForm from 'src/layouts/myAccount/ProfileForm';
import UpdatePassword from 'src/layouts/myAccount/UpdatePassword';
import palette from 'src/theme/palette';

export default function MyAccount() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page title={`My Account | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Typography
        sx={{
          fontSize: 25,
          fontFamily: 'poppinsSemiBold',
          padding: '0 10px 0 10px',
          marginBottom: 1.5
        }}
      >
        My Account
      </Typography>
      <Box
        sx={{
          px: 1,
          borderTop: `1px solid ${palette.primary.main}`, // light blue top border
          borderBottom: `1px solid ${palette.primary.main}` // light blue bottom border
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          TabIndicatorProps={{ style: { display: 'none' } }} // hide underline
          aria-label="account tabs"
        >
          <Tab
            label="Account"
            sx={{
              fontFamily: 'poppinsLight',
              color: value === 0 ? palette.primary.main : palette.primary.disabled,
              fontSize: 13
            }}
          />
          <Tab
            label="Change Password"
            sx={{
              fontFamily: 'poppinsLight',
              color: value === 1 ? palette.primary.main : palette.primary.disabled,
              fontSize: 13
            }}
          />
        </Tabs>
      </Box>
      {value === 0 && <ProfileForm />}
      {value === 1 && <UpdatePassword />}
    </Page>
  );
}
